import React, {Component, Fragment}  from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom';
import {get} from "../../../server/actions";
import moment from  'moment';
import {
    _addNotificationError,
    getOrderMonthYearByStudent,
    allowNumericWithdecimal,
    _addNotification,
    getGradeNumberByText, 
    getModuleEnum,
    getAccessLevelByModule,
    gradeTextToNumber,
    setSchoolsModule, setSchoolsPaymentGateways,
    isRegularLunchOrderType, getSchoolGrades, groupBy} from "../../../server/util";
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
var _ = require('lodash');
const data=[{
    name: "student one",
    status: 5,
    grade : "Reduced",
    eligibility : 3,

},
{
    name: "student two",
    status: 6,
    grade : "",
    eligibility : 2
    
}]
class MealBenifitsApplications extends Component {
    constructor(props) {
        super(props)
        
        this.state={
            loading:false,
            initStep:0,
            applicationsData:[],
            sid:"",
            districtStatus:true,
            studentList:this.props.studentList,
            schoolObject:{},
            draftData: {}
           
        }
       
        this.getAllApplications=this.getAllApplications.bind(this);
        this.getSaveData=this.getSaveData.bind(this);
    }
    componentWillMount=()=>{
        const {schoolObject,sid} = this.context.router.route.location.state;
        console.log(schoolObject,sid)
       console.log(this.props.studentList)
        this.setState({sid,schoolObject})
       // sessionStorage.setItem("districtStatus", districtStatus )
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
       // this.getStudentUsersByParent()
        this.getAllApplications();
        this.getSaveData();
    }
    
    getAllApplications=()=>{
        this.setState({loading:true})
        const schoolYear = this.state.schoolObject.sessionYear.schoolYearValue
        const parentEmail = sessionStorage.getItem("loggedInUserInfo")
        get(`/getStdAppInfo?mealSchoolId=${this.state.sid}&schoolYear=${schoolYear}&parentEmails=${parentEmail}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const updatedData = data.response.reduce((accumulator, current) => {
                const existingIndex = accumulator.findIndex((item) => item.stdRecId === current.stdRecId);
                if (existingIndex !== -1) {
                  accumulator[existingIndex] = current;
                } else {
                   accumulator.push(current);
                }
              return accumulator;
              }, []);
              console.log("updatedData:::::::::::",updatedData);
            //const updatedData = data.response.filter(item => item.appStatus !== "draft");
           this.setState({ loading:false, 
            applicationsData:updatedData
            });
        })
        .catch(
            (error) => {
                this.setState({loading:false})
                console.log('Get getAllApplications response', error)
            }
        )
    }

    getSaveData= async (type)=>{
        console.log("State _lunchBreakfastObj::::",this.state.lunchBreakfastObj);
        //let _lunchBreakfastObj=this.props.lunchObj;
        this.setState({ loading: true });
       // const suchoolYearValue = this.state.schoolObject.sessionYear.schoolYearValue
        get('/getHouseholdAppById?parentEmail=' + sessionStorage.getItem('loggedInUserInfo') + "&access_token=")
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log("Draft Data:::::::::::",data);
            console.log("Data::::",data);
            console.log("lunchBreakfastObj state:::::",this.state.lunchBreakfastObj);
            this.setState({draftData: data, loading: false });
            this.props.setDraftData(this.state.draftData);
            console.log("DraftData::::::",this.state.draftData);
        }).catch(
                (error) => {
                    this.setState({ loading: false });
                    if(this.state.draftData.hasOwnProperty('applicationId')){
                        delete this.state.draftData['applicationId'];
                    }
                    console.log('Get School data response', error)
                }
            );
        }

    render (){
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>                
                    <section className=" full-width clearfix margin-top">
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container">                        
                            <div className="row">
                                <div className="col-md-6 col-sm-12 col-xs-12 form-group sectionTitle">
                               <h2><span>Eligibility Applications</span></h2> 
                                </div>
                                <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                                <Link className="btn btn-warning button-sm add-btn-sm" 
                                
                                onClick={() => {this.setState({districtStatus:'true'})}}
                                
                                to={{pathname:'/parent/lunchbreakfastprogram/'+this.state.sid,
                                state:{
                                    schoolObject:this.state.schoolObject,
                                    sid:this.state.sid, 
                                    studentList:this.state.studentList,   
                                    districtStatus:this.state.districtStatus                                
                                }}}><i className="fa fa-plus"/> Family Application</Link>
                                <Link className="btn btn-success button-sm add-btn-sm"  style={{marginRight:'10px'}}
                                to={{pathname:'/parent/lunchbreakfastprogram/'+this.state.sid,
                                state:{
                                    schoolObject:this.state.schoolObject,
                                    sid:this.state.sid,
                                }
                                }}><i className="fa fa-plus"/> New Application</Link>
                                </div>
                            </div>        
                            <div className="row">
                                <div className="col-xs-12">
                                <ReactTable
                                    data={this.state.applicationsData}
                                    columns={[{
                                        Header: "Name", width: 250,
                                        Cell: (props) => {
                                            return <span >{props.original.stdFirstName +" "+props.original.stdLastName}</span>
                                        }
                                    },
                                    { 
                                        Header: "Status ", 
                                        width: 200, 
                                        accessor: "appStatus",
                                        Cell: ({ row }) => {
                                            return(
                                            <div style={{textAlign:"center"}}>
                                                {
                                                    row._original.appStatus==='declined'?
                                                    <span><i className="fa fa-circle color-3"></i> Verified</span>:
                                                    row._original.appStatus==='in-complete'?<Fragment>
                                                    <i className="fa fa-circle color-1"></i> <a className="btn-linkedin-link" style={{padding:'0px',cursor:'pointer'}}
                                                    data-tip data-for={'rtd-'+row._original.applicationId}>
                                                    {'In-complete'}</a> 
                                                    <ReactTooltip multiline={true} id={'rtd-'+row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                                    <div>
                                                    <ul style={{textAlign:'left'}}>
                                                            {(row._original.incompleteReasonList||[]).map((item,i)=>{
                                                                if(item.isApplicable){
                                                                    return <li>{item.name==='Other:'?item.description:item.name
                                                                    }</li>
                                                                }
                                                                
                                                            })}
                                                        </ul>
                                                   
                                                    </div>
                                                    </ReactTooltip>
                                                </Fragment>:
                                                    row._original.appStatus==='approved'?
                                                    <span><i className="fa fa-circle color-2"></i> Verified</span>:
                                                    row._original.appStatus==='cancelled'?
                                                    <Fragment>
                                                        <i className="fa fa-circle color-3"></i> <a className="btn-linkedin-link" style={{padding:'0px',cursor:'pointer'}}
                                                        data-tip data-for={'rtd-'+row._original.applicationId}>
                                                        {'Cancelled'}</a> 
                                                        <ReactTooltip multiline={true} id={'rtd-'+row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                                        <div>
                                                            {row._original.cancelledNote}
                                                            
                                                        </div>
                                                        </ReactTooltip>
                                                    </Fragment>:
                                                     row._original.appStatus==='denied'?
                                                     <span><i className="fa fa-circle color-3"></i>Denied</span>:
                                                     row._original.appStatus==='draft'?
                                                    <span><i className="fa fa-circle color-4"></i> Draft</span>:
                                                    <span><i className="fa fa-circle color-4"></i>pending </span>
                                                }
                                            </div>
                                    )},
                                 },
                                    { Header: "Grade", width: 200, 
                                    Cell:(props)=>{
                                        const gradeGroup=groupBy(getSchoolGrades(this.state.sid),'value');
                                        const label=((gradeGroup[props.original.grade]||[])[0]||{}).label;
                                        return <Fragment>
                                            {label}
                                            </Fragment> }},
                                    { Header: "Eligibility", width: 150, accessor: "eligibility" },
                                    { Header: "ACTION", width: 200,
                                        style: {textAlign: 'center'},
                                        Cell:(props)=>{
                                           return <Fragment>
                                           {props.original.appStatus=== "approved" || props.original.appStatus=== "denied" ? 
                                            <Link 
                                            to={{pathname:'/parent/mealbenifitsapplication/details/'+props.original.appId,
                                                state:{
                                                    appid:props.original.appId,
                                                    sid:this.state.sid,
                                                    schoolObject : this.state.schoolObject
                                                }}}
                                            className="edit-btn"><i
                                                            className="fa fa-eye tbl-rounded-icon bg-color-1 fa-icon"/></Link>

                                            :props.original.appStatus=== "draft" ?<Link
                                            to={{pathname:'/parent/lunchbreakfastprogram/'+this.state.sid,
                                            state:{
                                                sid:this.state.sid,
                                                schoolObject : this.state.schoolObject
                                            }}}
                                            className="eye-btn"><i title="Click to edit application."
                                                            className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></Link>
                                            :<Link
                                            to={{pathname:'/parent/mealbenifitsapplication/details/'+props.original.appId,
                                            state:{
                                                appid:props.original.appId,
                                                sid:this.state.sid,
                                                schoolObject : this.state.schoolObject
                                            }}}
                                            className="eye-btn"><i title="Click to edit report for application."
                                                            className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></Link>

                                            }
                                            </Fragment>
                                       }  }
                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight rtTable-Order"
                                    noDataText='No data found'
                                 />
                                </div>
                            </div>
                            <br/>        
                            <div className="text-right">
                            <ul >
                                <li>
                                <Link
                                    to='/parent'
                                    className="btn btn-primary ">
                                    Back
                                    
                                    </Link>
                                </li>
                            
                        </ul>
                    </div>
                        </div>
                    </section>
            </div>
        )
    }
}

MealBenifitsApplications.contextTypes = {
    router: PropTypes.object.isRequired
}

export default MealBenifitsApplications


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolMealBenifitsApplications/mealBenifitsApplications.jsx